import React, { useState } from 'react';
import { api, resolveImg } from '../../api';
import ImageUploader from './ImageUploader';
import { Plus, Trash2, Save, X, Pencil } from 'lucide-react';

const empty = { img: '', nameFr: '', nameEn: '', material: 'Cobalt Chrome', order: 0 };

const GrillzAdmin = ({ content, refresh }) => {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const startNew = () => { setForm({ ...empty, order: (content.grillz?.length || 0) }); setEditing('new'); };
  const startEdit = (g) => { setForm({
    img: g.img || '',
    nameFr: g.nameFr || '',
    nameEn: g.nameEn || '',
    material: g.material || 'Cobalt Chrome',
    order: g.order || 0,
  }); setEditing(g.id); };
  const cancel = () => { setEditing(null); setForm(empty); };

  const save = async () => {
    if (!form.img) { alert('Veuillez téléverser une photo'); return; }
    const payload = { ...form, priceFrom: '' };
    if (editing === 'new') {
      await api.post('/admin/grillz', payload);
    } else {
      await api.put(`/admin/grillz/${editing}`, payload);
    }
    await refresh();
    cancel();
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer ce grillz ?')) return;
    await api.delete(`/admin/grillz/${id}`);
    await refresh();
  };

  const items = content.grillz || [];

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="h-display text-[32px]">Grillz</h2>
          <p className="text-[13px] text-[#8A8275] mt-1">
            Gérez la collection grillz sur mesure (Cobalt Chrome). {items.length} modèles.
          </p>
        </div>
        <button onClick={startNew} className="btn-primary"><Plus size={14} /> Ajouter</button>
      </div>

      {editing && (
        <div className="bg-[#FAF8F4] border border-[#957340] p-6 mb-8">
          <div className="flex items-center justify-between mb-5">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#957340]">
              {editing === 'new' ? 'Nouveau grillz' : 'Modifier'}
            </div>
            <button onClick={cancel}><X size={16} /></button>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <div className="md:col-span-2">
              <ImageUploader value={form.img} onChange={(v) => setForm({ ...form, img: v })} label="Photo du grillz" />
            </div>
            <Inp label="Nom (FR)" value={form.nameFr} onChange={(v) => setForm({ ...form, nameFr: v })} />
            <Inp label="Nom (EN)" value={form.nameEn} onChange={(v) => setForm({ ...form, nameEn: v })} />
            <Inp label="Matière" value={form.material} onChange={(v) => setForm({ ...form, material: v })} />
            <Inp label="Ordre d'affichage" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: parseInt(v) || 0 })} />
          </div>
          <div className="mt-6 flex gap-3">
            <button onClick={save} className="btn-primary"><Save size={14} /> Enregistrer</button>
            <button onClick={cancel} className="btn-ghost">Annuler</button>
          </div>
        </div>
      )}

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5">
        {items.map((g) => (
          <div key={g.id} className="bg-white border border-[#E8E2D5] overflow-hidden">
            <div className="aspect-square bg-[#FAF8F4]">
              {g.img && <img src={resolveImg(g.img)} alt={g.nameFr} className="w-full h-full object-cover" />}
            </div>
            <div className="p-4">
              <div className="serif text-[16px] text-[#1A1A1A]">{g.nameFr || '—'}</div>
              <div className="text-[11px] tracking-[0.2em] uppercase text-[#957340] mt-1">{g.material || ''}</div>
              <div className="text-[11px] text-[#8A8275] mt-1">{g.nameEn}</div>
              <div className="flex gap-2 mt-4">
                <button onClick={() => startEdit(g)} className="flex-1 border border-[#1A1A1A] py-2 text-[10px] tracking-[0.28em] uppercase hover:bg-[#1A1A1A] hover:text-white transition-colors flex items-center justify-center gap-2">
                  <Pencil size={12} /> Modifier
                </button>
                <button onClick={() => del(g.id)} className="px-3 py-2 border border-[#E8E2D5] text-[#8A8275] hover:text-red-600 hover:border-red-600 transition-colors">
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Inp = ({ label, value, onChange, type = 'text' }) => (
  <label className="block">
    <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
    <input type={type} value={value ?? ''} onChange={(e) => onChange(e.target.value)}
      className="mt-2 w-full bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px] transition-colors" />
  </label>
);

export default GrillzAdmin;
